import { None, Option, Some } from "./monads"

export class Numbers {
  static parseIntOption(str: string): Option<number> {
    const z = parseInt(str)
    return Number.isNaN(z) ? None : Some(z)
  }
}
